// extracted by mini-css-extract-plugin
export default {"ChartCompetitorList":"ChartCompetitorList_ChartCompetitorList__-4S9l","ChartCompetitorList__ChartContainer":"ChartCompetitorList_ChartCompetitorList__ChartContainer__-KMc2"};